export default __webpack_public_path__ + "static/media/redlike-user.6a8b2687.svg";